import React, { PureComponent, ReactNode } from 'react'
import { Page } from '../../components'

class Penalties extends PureComponent {
  public render(): ReactNode {
    return (
      <Page>
        Penalties
      </Page>
    )
  }
}

export default Penalties
